import { tg } from "../telegram";
import { useT } from "../i18n";

/**
 * Shown when the user opens the Mini App URL outside Telegram (e.g. directly
 * in a browser). Backend will 401 the API anyway because `initData` is empty
 * and the HMAC check fails — but a friendly hint is nicer than raw errors.
 */
export default function DesktopHint() {
  const { t } = useT();
  return (
    <div style={{
      padding: 40, textAlign: "center", maxWidth: 480, margin: "0 auto",
    }}>
      <div style={{ fontSize: 48, marginBottom: 16 }}>🛠</div>
      <h1 style={{ marginTop: 0 }}>{t("desktop_hint.title")}</h1>
      <p style={{ color: "var(--hint)", fontSize: 14, lineHeight: 1.6 }}>
        {t("desktop_hint.body")}
      </p>
      <a
        href="https://t.me/energo9999_bot"
        style={{
          display: "inline-block",
          marginTop: 16,
          padding: "12px 20px",
          background: "var(--button)",
          color: "var(--button-text)",
          borderRadius: 10,
          textDecoration: "none",
          fontWeight: 600,
        }}
      >
        @energo9999_bot
      </a>
    </div>
  );
}

export function isInsideTelegram(): boolean {
  if (tg()?.initData) return true;
  // Dev-browser mode: ?u=<telegram_id> in the URL (or saved in localStorage
  // from a previous visit) acts as a pass-through. The API picks the id up
  // from the X-Dev-User-Id header; we just need DesktopHint to step aside.
  try {
    const fromUrl = new URLSearchParams(window.location.search).get("u");
    if (fromUrl) return true;
    if (localStorage.getItem("energo.dev_user_id")) return true;
  } catch {}
  return false;
}
